import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

const Loader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const loaderRef = useRef(null);
  const textRef = useRef(null);
  const brandRef = useRef(null);

  useEffect(() => {
    // Disable scrolling while loading
    document.body.style.overflow = 'hidden';
    
    const tl = gsap.timeline({
      onComplete: () => {
        document.body.style.overflow = '';
        if(onComplete) onComplete();
      }
    });

    // Animate progress
    tl.to({ value: 0 }, {
      value: 100,
      duration: 1.5,
      ease: "power3.inOut",
      onUpdate: function() {
        setProgress(Math.round(this.targets()[0].value));
      }
    });

    // Stagger exit
    tl.to([textRef.current, brandRef.current], {
      y: -50,
      opacity: 0,
      duration: 0.5,
      stagger: 0.1,
      ease: "power2.in"
    });

    // Lift off the entire loader background
    tl.to(loaderRef.current, {
      yPercent: -100,
      duration: 1,
      ease: "expo.inOut"
    });

  }, [onComplete]);

  return (
    <div 
      ref={loaderRef}
      className="fixed inset-0 z-[100] bg-foreground text-background flex items-center justify-center font-sans"
    >
      <div className="overflow-hidden">
        <h1 
          ref={textRef}
          className="text-[15vw] leading-none font-bold tracking-tighter"
        >
          {progress}%
        </h1>
      </div>
    </div>
  );
};

export default Loader;
